import { LinkHub, LinkHubSkeleton } from "@/components";
import { CONTACT, PLATFORM_SITE_URL, SOCIAL_MEDIA } from "@/constants";
import { useLinkHubLanding } from "@/hooks";
import { linkPropsByDevice, PLATFORM_SITE_NAME } from "@/utils";

/**
 * Tenant public home — same layout as global landing, tenant-specific config
 */
const TenantLanding: React.FC = () => {
  const { config, loading, error } = useLinkHubLanding();

  if (loading) {
    return (
      <div className="container">
        <LinkHubSkeleton />
      </div>
    );
  }

  if (error || !config) {
    return (
      <div className="container">
        <p>{error?.message ?? "No se pudo cargar el sitio del espacio."}</p>
      </div>
    );
  }

  return (
    <div className="container">
      <LinkHub config={config} />
      <div className="landing__footer">
        <p>
          Todas las salas de teatro de la ciudad en{" "}
          <a href={PLATFORM_SITE_URL} {...linkPropsByDevice}>
            {PLATFORM_SITE_NAME}
          </a>
          .
        </p>
        <p>
          ¿Querés una página como esta? Pedila en{" "}
          <a href={SOCIAL_MEDIA.WHATSAPP_NEW_PAGE} {...linkPropsByDevice}>
            {CONTACT.PHONE}
          </a>
        </p>
      </div>
    </div>
  );
};

export default TenantLanding;
